module.exports = __webpack_public_path__ + "static/media/info.dc7f59f1.svg";